import { defineComponent as t, openBlock as n, createBlock as r, unref as m, mergeProps as p, withCtx as v, createElementVNode as c } from "vue";
import { RevIcon as l } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconHome",
  __name: "IconHome",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const a = o;
    return (s, e) => (n(), r(m(l), p(a, { "view-box": "0 0 24 24" }), {
      default: v(() => [...e[0] || (e[0] = [
        c("path", { d: "M12.768 2.83a1.25 1.25 0 0 0-1.535 0L2.54 9.591a.75.75 0 1 0 .92 1.184L12 4.133l8.54 6.642a.75.75 0 1 0 .92-1.184L12.769 2.83M5.75 12.183a.75.75 0 0 0-1.5 0v8a1.25 1.25 0 0 0 1.25 1.25h4a1.25 1.25 0 0 0 1.25-1.25v-3.5a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 0 0 1.25 1.25h4a1.25 1.25 0 0 0 1.25-1.25v-8a.75.75 0 0 0-1.5 0v7.75h-3.5v-3.25a2.75 2.75 0 1 0-5.5 0v3.25h-3.5v-7.75" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
